import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Card from '../pages/Card';
import Layout from './Layout';




function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/card" element={<Card />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;